import { sendGTMEvent } from '@next/third-parties/google';

import {
  ISUZU_CARE_FORM_ID,
  MAXFORCE_FORM_ID,
  REGISTER_CV_FORM_ID,
  REGISTER_LCV_FORM_ID,
  TELETEC_FORM_ID,
  TRUCK2HAND_FORM_ID,
} from '@/services/contentstack/common/form';
import { formatModelForFacebookTracking } from '@/tag-manager';

export const FORM_SUBMISSION_EVENTS = {
  REGISTER_INTEREST: 'submit-crp-register-interest',
  REGISTER: 'submit-crp-register',
};

const SKIP_TRACKING_FORM_IDS = [
  ISUZU_CARE_FORM_ID,
  TELETEC_FORM_ID,
  TRUCK2HAND_FORM_ID,
];

interface TrackFormSubmissionParams {
  formId: string;
  contentIds?: string;
  model: string;
  dealer?: string;
  province?: string;
  district?: string;
  branchCode: string;
  fbModel?: string;
}

export const trackFormSubmission = ({
  formId,
  contentIds,
  dealer,
  province,
  district,
  branchCode,
  model,
  fbModel,
}: TrackFormSubmissionParams) => {
  if (SKIP_TRACKING_FORM_IDS.includes(formId)) {
    return;
  }

  const defaultParams = {
    id: branchCode,
    district: district ?? '',
    city: province ?? '',
    dealerName: dealer ?? '',
  };

  switch (formId) {
    case REGISTER_LCV_FORM_ID:
    case REGISTER_CV_FORM_ID:
    case MAXFORCE_FORM_ID:
      sendGTMEvent({
        event: FORM_SUBMISSION_EVENTS.REGISTER_INTEREST,
        ...defaultParams,
        content_ids: contentIds,
        model: model ? formatModelForFacebookTracking(model) : '',
      });
      break;
    default:
      sendGTMEvent({
        event: FORM_SUBMISSION_EVENTS.REGISTER,
        ...defaultParams,
        content_ids: fbModel ?? '',
      });
      break;
  }
};
